import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectApplicationField');

    return {
        APPLICATION: t('application'),
        APPLICATION_IS_REQUIRED: t('applicationIsRequired')
    };
};

export default useTranslation;
